import {Pipe, PipeTransform} from '@angular/core';
import {clFormatFilesize} from '@castlabs/ui';

/*
 * Convert bytes into largest possible unit.
 * Usage:
 *   bytes | fileSize
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 */
@Pipe({
    name: 'fileSize'
})
export class FileSizePipe implements PipeTransform {

    transform(bytes: number = 0): string {
        return clFormatFilesize(bytes);
    }
}
